import React, { useEffect, useState } from 'react';
import { Outlet, Link, useSearchParams, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { setLanguage } from '../features/langSlice';
import { normalizeLanguageCode } from '../utils/language';
import LogoSvg from '../assets/logo.svg';
import { ToastContainer } from 'react-toastify';

const LANGUAGE_OPTIONS = [
  { code: 'de', label: 'DE' },
  { code: 'en', label: 'EN' },
  { code: 'fr', label: 'FR' },
];

const PostPurchaseHeader = () => {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const currentUrlLang = searchParams.get('lang');
  const [selected, setSelected] = useState(() => normalizeLanguageCode(currentUrlLang || localStorage.getItem('lang') || 'de'));

  useEffect(() => {
    const nextLang = normalizeLanguageCode(currentUrlLang || localStorage.getItem('lang') || 'de');

    if (localStorage.getItem('lang') !== nextLang) {
      localStorage.setItem('lang', nextLang);
    }

    if (normalizeLanguageCode(i18n.language) !== nextLang) {
      i18n.changeLanguage(nextLang);
    }

    dispatch(setLanguage({ lng: nextLang }));

    if (selected === nextLang) return;

    setSelected(nextLang);
  }, [currentUrlLang, dispatch, i18n, selected]);

  const changeLanguage = (lng) => {
    const nextLang = normalizeLanguageCode(lng);

    localStorage.setItem('lang', nextLang);
    i18n.changeLanguage(nextLang);
    const newParams = new URLSearchParams(searchParams);
    newParams.set('lang', nextLang);
    navigate({ search: newParams.toString() });
    setSelected(nextLang);
    dispatch(setLanguage({ lng: nextLang }));
  };

  return (
    <header className="ppl-header">
      <Link to="/" className="ppl-header__logo">
        <img src={LogoSvg} alt="riise" height="28" />
      </Link>
      <div className="ppl-header__lang">
        {LANGUAGE_OPTIONS.map((option, index) => (
          <React.Fragment key={option.code}>
            {index > 0 && <span className="ppl-lang-sep">|</span>}
            <button
              className={`ppl-lang-btn${selected === option.code ? ' ppl-lang-btn--active' : ''}`}
              onClick={() => changeLanguage(option.code)}
            >
              {option.label}
            </button>
          </React.Fragment>
        ))}
      </div>
    </header>
  );
};

const PostPurchaseLayout = () => (
  <>
    <PostPurchaseHeader />
    <Outlet />
    <ToastContainer />
  </>
);

export default PostPurchaseLayout;
